import { z } from "zod";

export const emailSchema = z.string().min(1, "Informe o email").email("Email inválido");

export const passwordSchema = z
  .string()
  .min(6, "Mínimo de 6 caracteres")
  .max(128, "Senha muito longa");

export const signInSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
});

export const signUpSchema = z.object({
  full_name: z.string().min(2, "Informe seu nome").max(120),
  email: emailSchema,
  password: passwordSchema,
});

/**
 * Aceite de termos é coletado IMPLICITAMENTE no signup ("Ao criar conta,
 * você aceita..."). O onboarding só pede dados pedagógicos.
 */
export const onboardingSchema = z.object({
  exam_date: z
    .string()
    .min(1, "Informe a data prevista da prova")
    .refine((d) => !Number.isNaN(Date.parse(d)), "Data inválida"),
  weekly_hours: z
    .number({ invalid_type_error: "Informe um número" })
    .min(1, "Pelo menos 1 hora")
    .max(60, "No máximo 60 horas"),
  consent_research: z.boolean(),
});

export const passwordResetRequestSchema = z.object({ email: emailSchema });
export const passwordResetSchema = z
  .object({
    password: passwordSchema,
    confirm: passwordSchema,
  })
  .refine((v) => v.password === v.confirm, {
    message: "Senhas não conferem",
    path: ["confirm"],
  });

export const profileSettingsSchema = z.object({
  display_name: z.string().min(1, "Como devo te chamar?").max(60),
  exam_date: z
    .string()
    .min(1, "Informe a data prevista")
    .refine((d) => !Number.isNaN(Date.parse(d)), "Data inválida"),
  weekly_hours: z
    .number({ invalid_type_error: "Número de horas" })
    .min(1)
    .max(60),
  consent_research: z.boolean(),
});

export type ProfileSettingsValues = z.infer<typeof profileSettingsSchema>;

export type SignInValues = z.infer<typeof signInSchema>;
export type SignUpValues = z.infer<typeof signUpSchema>;
export type OnboardingValues = z.infer<typeof onboardingSchema>;
export type PasswordResetRequestValues = z.infer<typeof passwordResetRequestSchema>;
export type PasswordResetValues = z.infer<typeof passwordResetSchema>;
export { signInSchema as _signInSchema };
